import Enquiry from '@data/model/NewModals/Enquiry'

import {
	ADD_NEW_ITEM_TO_ENQUIRY,
	CREATE_NEW_ENQUIRY,
	CREATE_NEW_ENQUIRY_FROM_DATA,
	FETCH_BRANDS_SUCCESS,
	FETCH_BRANDS_PROGRESS,
	FETCH_CATEGORIES_FAILURE,
	FETCH_CATEGORIES_PROGRESS,
	FETCH_CATEGORIES_SUCCESS,
	UPDATE_ENQUIRY_ITEM,
	DELETE_ENQUIRY_ITEM,
	UPDATE_NEW_ENQUIRY,
	CREATE_ENQUIRY_PROGRESS,
	CREATE_ENQUIRY_SUCCESS,
	CREATE_ENQUIRY_FAILURE,
	UPDATE_ENQUIRY_PROGRESS,
	UPDATE_ENQUIRY_SUCCESS,
	UPDATE_ENQUIRY_FAILURE,
	CLEAR_NEW_ENQUIRY,
} from './actions'
import { SpoEnquiryItem } from '@data/model'

export const statusMap = {
	IN_PROGRESS: 'IN_PROGRESS',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
}

export const initialState = {
	newEnquiry: null,
	newEnquiryStatus: {},
	categories: {
		loading: false,
		error: null,
		data: null,
	},
	brands: {
		data: null,
		loading: false,
	},
}

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case CREATE_NEW_ENQUIRY: {
			const user = action.user
			const newEnquiry = new Enquiry({
				buyer_id: user.user_id,
				created_by: user.user_id,
				commodity: user?.commodity?.find((item) => item.active),
				buyer: {
					...user?.getUserDetails(),
					is_primary: null,
				},
			})
			return { ...state, newEnquiry }
		}
		case CREATE_NEW_ENQUIRY_FROM_DATA: {
			const data = action.data
			const newEnquiry = new Enquiry(data)
			return { ...state, newEnquiry }
		}
		case UPDATE_NEW_ENQUIRY: {
			let newEnquiry = state?.newEnquiry
			if (newEnquiry && action.payload) {
				newEnquiry = newEnquiry.update(action.payload)
				return { ...state, newEnquiry }
			}
			return state
		}
		case ADD_NEW_ITEM_TO_ENQUIRY: {
			let newEnquiry = state?.newEnquiry
			if (newEnquiry) {
				const enquiryItem = new SpoEnquiryItem(action.payload)
				newEnquiry = newEnquiry.addNewItem(enquiryItem, enquiryItem.is_unknown_product)
				return { ...state, newEnquiry }
			}
			return state
		}
		case UPDATE_ENQUIRY_ITEM: {
			let newEnquiry = state?.newEnquiry
			if (newEnquiry && action.itemId) {
				const enquiryItem = new SpoEnquiryItem(action.payload)
				newEnquiry = newEnquiry.updateItem(action.itemId, enquiryItem)
				return { ...state, newEnquiry }
			}
			return state
		}
		case DELETE_ENQUIRY_ITEM: {
			let newEnquiry = state?.newEnquiry
			if (newEnquiry && action.itemId) {
				newEnquiry = newEnquiry.deleteItem(action.itemId)
				return { ...state, newEnquiry }
			}
			return state
		}

		case FETCH_CATEGORIES_PROGRESS: {
			return {
				...state,
				categories: {
					loading: true,
				},
			}
		}
		case FETCH_CATEGORIES_SUCCESS: {
			return {
				...state,
				categories: {
					loading: false,
					data: action.payload,
				},
			}
		}
		case FETCH_CATEGORIES_FAILURE: {
			return {
				...state,
				categories: {
					loading: false,
					error: action.error,
				},
			}
		}
		case FETCH_BRANDS_PROGRESS: {
			return {
				...state,
				brands: {
					loading: true,
				},
			}
		}
		case FETCH_BRANDS_SUCCESS: {
			return {
				...state,
				brands: {
					loading: false,
					data: action.payload,
				},
			}
		}

		case CREATE_ENQUIRY_PROGRESS: {
			return {
				...state,
				newEnquiryStatus: {
					status: statusMap.IN_PROGRESS,
				},
			}
		}
		case CREATE_ENQUIRY_SUCCESS: {
			return {
				...state,
				newEnquiryStatus: {
					status: statusMap.SUCCESS,
					data: action.data,
				},
			}
		}
		case CREATE_ENQUIRY_FAILURE: {
			return {
				...state,
				newEnquiryStatus: {
					status: statusMap.FAILURE,
					error: action.error,
				},
			}
		}

		case UPDATE_ENQUIRY_PROGRESS: {
			return {
				...state,
				newEnquiryStatus: {
					status: statusMap.IN_PROGRESS,
				},
			}
		}
		case UPDATE_ENQUIRY_SUCCESS: {
			return {
				...state,
				newEnquiryStatus: {
					status: statusMap.SUCCESS,
					data: action.data,
				},
			}
		}
		case UPDATE_ENQUIRY_FAILURE: {
			return {
				...state,
				newEnquiryStatus: {
					status: statusMap.FAILURE,
					error: action.error,
				},
			}
		}

		case CLEAR_NEW_ENQUIRY: {
			return {
				...initialState,
			}
		}

		default:
			return state
	}
}
